
















































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import OutlinedButton from '@/components/Buttons/OutlinedButton/index.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    OutlinedButton,
  },
})
export default class DeclineAvailability extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('declineNotes', {}) note!: string;

  @PropSync('availabilityEvent', {}) eventSync!: any;

  @Prop({}) loading!: boolean;

  @Prop({}) status!: boolean;

  public close() {
    this.$emit('cancel');
  }

  public onDecline() {
    if (this.adminUser) {
      this.note = '';
      this.$emit('decline', this.eventSync, this.note);
    }
    this.$emit('decline', this.eventSync, this.note);
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
